import React from "react";
import { Container, Typography, Button, Grid } from "@material-ui/core";
//

import { Link } from "react-router-dom";
//
import CartItem from "./CartItem/CartItem";
//
import useStyles from "./styles";

//
import RenderEmptyCart from "./IfCartisEmpty";
//

// ---------------
//
const Cart = ({ cart, onUpdateCartQty, onRemoveFromCart, onEmptyCart }) => {
  //wrapper of the container
  //containing the imgs from the checkout

  const classes = useStyles();

  //
  //
  //So if the cart is FILLED show the following:
  const renderCart = () => (
    <>
      <Grid container spacing={3}>
        {cart.line_items.map((item) => (
          // 4 = to 3 products on the desktop
          <Grid item xs={12} sm={12} key={item.id} md={6} lg={6}>
            <CartItem
              item={item}
              onUpdateCartQty={onUpdateCartQty}
              onRemoveFromCart={onRemoveFromCart}
            />
          </Grid>
        ))}
      </Grid>

      <div className={classes.cardDetails}>
        <Typography variant="h4" className={classes.subTotalTitle}>
          {/* with symbol, is going to give us the amount with the dollar sign but if you set it up to euro in commercejs , it will show euro*/}
          Subtotal: {cart.subtotal?.formatted_with_symbol}
        </Typography>
        {/* 
      
              Wrapper BTNs
      
      
       */}
        <div className={classes.wrapperEmptyBtnAndCheckoutBtn}>
          <Button
            className={classes.emptyButton}
            size="large"
            type="button"
            variant="contained"
            onClick={onEmptyCart}
          >
            Empty cart
          </Button>
          <Button
            component={Link}
            to="/checkout"
            className={classes.checkoutButton}
            size="large"
            type="button"
            variant="contained"
          >
            Checkout
          </Button>
        </div>
      </div>
    </>
  );

  //
  if (!cart.line_items) return "Loading";

  return (
    <Container>
      <div className={classes.toolbar} />
      <Typography className={classes.title} variant="h4" gutterBottom>
        YOUR SELECTIONS
      </Typography>
      {!cart.line_items.length ? <RenderEmptyCart /> : renderCart()}
    </Container>
  );
};

export default Cart;

/*
 gutterBottom is going to give something like a padding 60px ,wherever you place it  

*/
